import type { ShiftProductionForm } from "../../../shared/shift-production-form/contracts";

export function approvalRevisionView(form: ShiftProductionForm, requested: number | null, readOnly = false) {
  const numbers = [...new Set([form.revisionNumber, ...form.revisions.map(item => item.revisionNumber)])].sort((a, b) => b - a);
  const draft = form.status === "DRAFT" || form.status === "RETURNED";
  const selectedNumber = requested ?? form.revisionNumber;
  const revision = selectedNumber === form.revisionNumber && !draft ? null : form.revisions.find(item => item.revisionNumber === selectedNumber);
  const historical = Boolean(revision);
  return {
    numbers,
    selected: revision?.revisionNumber ?? form.revisionNumber,
    historical,
    form: revision ? { ...form, payload: revision.snapshot, submittedSnapshot: revision.snapshot, revisionNumber: revision.revisionNumber, canDecide: false } : readOnly ? { ...form, canDecide: false } : form,
  };
}
